import * as React from "react"
import {
  Container
} from '@chakra-ui/react';

const sectionWrapper = ({ shadedBG, hero, contactForm, children, className = ''}) => {
  const shadedClass = hero ? 'shaded' : 'shadedNonHero';
  const contactFormClass = contactForm ? 'contactFormSection' : '';
  const classes = className.split(' ');
  if (shadedBG)
    classes.push(shadedClass);
  if (contactForm)
    classes.push(contactFormClass);
  return (
    <section className={classes.length ? classes.join(' ') : ''}>
      <div className="sectionInner">
        <Container maxW='1440px' className={contactForm ? 'contactFormSectionContainer' : ''}>
          {children}
        </Container>
      </div>
    </section>
  )
}

export default sectionWrapper;